import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { H2 } from 'UIComponents/elements/headings';
import { GYPSUM, KOALA, OBSIDIAN } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDialogHeader = styled(UIFlex).withConfig({
  displayName: "MobilePanelHeader__StyledDialogHeader",
  componentId: "sc-8rzvcm-0"
})(["&&{min-height:60px;color:", ";background-color:", ";border-bottom:2px solid ", ";flex:initial;margin-top:-40px;padding:0 4px;}"], OBSIDIAN, GYPSUM, KOALA);
const ItemWrapper = styled.div.withConfig({
  displayName: "MobilePanelHeader__ItemWrapper",
  componentId: "sc-8rzvcm-1"
})(["display:flex;flex:1;justify-content:center;text-align:center;"]);
const Title = styled(H2).withConfig({
  displayName: "MobilePanelHeader__Title",
  componentId: "sc-8rzvcm-2"
})(["font-weight:bold;font-size:14px;margin-bottom:0;"]);
StyledDialogHeader.displayName = 'StyledMobilePanelHeader';
export default function MobilePanelHeader({
  className,
  itemLeft,
  itemRight,
  title
}) {
  return /*#__PURE__*/_jsxs(StyledDialogHeader, {
    align: "center",
    justify: "around",
    className: className,
    children: [/*#__PURE__*/_jsx(ItemWrapper, {
      children: /*#__PURE__*/_jsx("span", {
        className: "m-right-auto",
        children: itemLeft
      })
    }), /*#__PURE__*/_jsx(ItemWrapper, {
      children: /*#__PURE__*/_jsx(Title, {
        children: title
      })
    }), /*#__PURE__*/_jsx(ItemWrapper, {
      children: /*#__PURE__*/_jsx("span", {
        className: "m-left-auto",
        children: itemRight
      })
    })]
  });
}